/**
 * Shared constants for the Compare Scenario panel.
 *
 * Extracted out of `CompareScenarioPanel.js` during the Feb-2026
 * maintainability refactor so the parent component stays focused on
 * state + orchestration while these values can be referenced (and
 * unit-tested) independently.
 */

export const MODIFIER_DEFS = [
  { key: 'governance', label: 'Governance', min: 0.7, max: 1.4, step: 0.05 },
  { key: 'content_readiness', label: 'Content Readiness', min: 0.7, max: 1.4, step: 0.05 },
  { key: 'integration_complexity', label: 'Integration Complexity', min: 0.7, max: 1.4, step: 0.05 },
  { key: 'org_complexity', label: 'Org Complexity', min: 0.7, max: 1.5, step: 0.05 },
  { key: 'timeline_pressure', label: 'Timeline Pressure', min: 0.8, max: 1.3, step: 0.05 },
  { key: 'client_capability', label: 'Client Capability', min: 0.7, max: 1.4, step: 0.05 },
  { key: 'change_readiness', label: 'Change Readiness', min: 0.7, max: 1.4, step: 0.05 },
];

export const COMPLEXITY_OPTIONS = [
  { value: 'simple', label: 'Simple' },
  { value: 'standard', label: 'Standard' },
  { value: 'complex', label: 'Complex' },
];
